import React from "react";
import "./../../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./../../../../node_modules/jquery/src/jquery.js";
import "./../../../../node_modules/bootstrap/dist/js/bootstrap.min.js";
import "../../../../node_modules/font-awesome/css/font-awesome.min.css";
import "../../Styles/app.css";
import "./Styles/style.css";
import "react-bootstrap-country-select/dist/react-bootstrap-country-select.css";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import Select from "react-dropdown-select";
import { formatPhone } from "../../../helper/utility";
import GLOBAL_CONST from '../../../helper/AppConstants';

import {
  saveRegistrationInfo,
  addUserPhoneNumber,
  userPhoneNumberClear,
  getCountryCodes,
  setHelpList,
  showModal, hideModal,
} from "../../../common/actions/userAccount";
import {
  RegisterFooter,
  RegisterHeader,
  RegisterWizard,
  SubmitButton,
} from "../../CommonComponents";

import { createLoadingSelector } from "../../../common/reducers/selectors";
const loadingSelector = createLoadingSelector(["add_phone_number_user"]);
// toast.configure() ;
const regExpr = /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;
const defaultCountry = { "CountryId": 1, "CountryName": "USA", "CountryCode": "+1", "label": "USA(+1)" }

class RegisterPhone extends React.Component {
  constructor(props) {
    super(props);
    let { registeredCountryCode, registeredCountryName } = this.props;
    if (registeredCountryCode === null) registeredCountryCode = "+1";
    if (registeredCountryName === null) registeredCountryName = "USA";
    const { registeredPhone } = this.props
    this.state = {
      countryCode: registeredCountryCode,
      countryName: registeredCountryName,
      phone: (registeredPhone?registeredPhone:''),
      phoneInvalid: "",
      selectedCountryCode:
        registeredCountryCode !== null ? registeredCountryCode : "",
      selectedCountry: this.getCountry(),
    };
    this.selectedCountry = React.createRef();
    this.phone = React.createRef();

    this.dosetHelpList()
    this.props.doGetCountryCodes()
  }


  dosetHelpList = () => {
    this.props.dosetHelpList({
      stackType: "Registration",
      screen: GLOBAL_CONST.SCREEN_NAMES.REGISTRATION_PHONE,
      title: this.props.t('regCardScr-regAccount'),
    });
  }
  openHelpModal = () => {
    this.props.doShowModal({
      modalScreenName: "HelpListing",
      modalClassName: "helpSupportModal sidebar-modal right",
      params: {
        stackType: this.props.setHelpListData.stackType,
        screen: this.props.setHelpListData.screen,
        title: this.props.setHelpListData.title,
      }
    });
  }

  getCountry() {
    const { registeredCountryName, countryCodeListing } = this.props
    if (!countryCodeListing) return
    const items = countryCodeListing.filter(item => {
      return item.CountryName === registeredCountryName
    })
    if (items && items.length > 0) {
      return items
    }
    return [defaultCountry]
  }

  saveCountry = (value) => {
    if (value && value.length > 0) {
      this.setState({ selectedCountry: value, countryCode: value[0].CountryCode, countryName: value[0].CountryName });
      this.phone.current.focus();
    }
  };
  submitForm = () => {
    const { phone, countryCode, countryName } = this.state;
    const { doSaveRegistrationInfo, doAddUserPhoneNumber } = this.props;
    //const reg = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
    // const reg = /^\+(?:[0-9] ?){6,14}[0-9]$/;
    // console.log(phone.match(reg))

    // if (phone.match(reg)=== null) {
    //   this.setState({ phoneInvalid: translate("regPhoneScr-phoneInvalid") });
    //   return;
    // }  
    if (phone.length <= 7) {
      this.setState({ phoneInvalid: this.props.t("regPhoneScr-phoneInvalid") });
      return;
    }
    // else if(countryCode=='+1' && phone.startsWith("1")){
    //   this.setState({ phoneInvalid: translate("regPhoneScr-phoneInvalid") });

    // }
    if (phone === this.props.registeredPhone && countryName === this.props.registeredCountryName) {
      this.props.history.replace("/confirmPhone");
      return;
    }
    let finalPhone = phone.replace(/[^0-9]/g, '')
    let countryCodeOnly = countryCode.replace('+', '')

    if (countryName === "USA" && finalPhone.charAt(0) == countryCodeOnly) {
      finalPhone = finalPhone.substring(1)
      console.log("finalPhone " + finalPhone)
    }

    this.setState({ phone: finalPhone }, () => {
      doAddUserPhoneNumber({
        PhoneNumber: this.state.phone,
        CountryCode: countryCode,
        ResendOTP: true,
      });
    })

  };
  handlePhoneChange = ({ target: { value: phone } }) => {
    this.setState({ phone: formatPhone(phone), phoneInvalid: "" });
  }

  componentDidUpdate() {
    const { addPhoneNumberResponse, error, userPhoneNumberClear, doSaveRegistrationInfo } = this.props;
    const { phone, countryCode, countryName } = this.state;
    if (error) {
      console.log("error",error)
      this.setState({ phoneInvalid: error.Message });
      userPhoneNumberClear();
    } else if (addPhoneNumberResponse) {
      doSaveRegistrationInfo({
        registeredPhone: phone,
        registeredCountryCode: countryCode,
        registeredCountryName: countryName,
      });
      this.props.history.push("/confirmPhone");
      userPhoneNumberClear();
    }
  }
  render() {
    const { phone, phoneInvalid, selectedCountry, countryCode } = this.state;
    const { isFetching, countryCodeListing } = this.props;
    console.log("phoneInvalid", phoneInvalid)
    return (
      <section className="registration">
        <div className="wrapper">
          <div className="landing-wrapper">
            <div className="row h-100vh nomargin-row">
              <RegisterHeader />
              <div className="col-sm-12 col-md-5 col-lg-5 col-xl-4 sidebar-col">
                <div className="sidebar-wrapper">
                  <form className="form-style1">
                    <RegisterWizard webPage={this.props.location.pathname} />
                    <div className="title-sect mb-40">
                      <h3 className="title-3">
                        {this.props.t("regPhoneScr-phoneNumber")}
                      </h3>
                      <p className="helptext">
                        {this.props.t("regPhoneScr-phoneDescription")}
                      </p>
                    </div>
                    <div className="form-group">

                      <Select
                        values={selectedCountry}
                        searchable={true}
                        options={countryCodeListing}
                        labelField={"label"}
                        valueField={"CountryId"}
                        onChange={(value) => this.saveCountry(value)}
                        searchBy={"label"}
                        clearOnSelect={true}
                        placeholder={this.props.t("Select_Country")}
                        name={this.selectedCountry}
                        className="form-control"
                        ref={this.selectedCountry}
                      />
                    </div>
                    <div className="form-group ">
                      <div className="input-group">
                        <input type="text"
                          className="form-control input-sm input-noflex"
                          readOnly={true}
                          value={countryCode}
                        />
                        <input
                          type="text"
                          className={`form-control ${phoneInvalid !== "" ? "input-error" : null
                            }`}
                          placeholder={this.props.t("regPhoneScr-phoneNumberPlace")}
                          value={phone}
                          onChange={this.handlePhoneChange}
                          maxLength={15}
                          onKeyPress={(event) => { if (event.key === 'Enter') this.submitForm(); }}
                          name="phone"
                          ref={this.phone}
                        />

                      </div>

                      <span className="error" id="message">
                        {" "}
                        {phoneInvalid}
                      </span>
                    </div>

                    <div className="form-group mb-40">
                      <button type="button" className="btn needhelp-label"
                        onClick={() => {
                          this.openHelpModal();
                        }}

                      >
                        {this.props.t("regNameScr-needHelp")}
                      </button>
                    </div>
                    <SubmitButton
                      nextAction={() => {
                        this.submitForm();
                      }}
                      loading={isFetching}
                    />
                  </form>
                  <RegisterFooter />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    registeredPhone: state.userAccount.registeredPhone,
    registeredCountryCode: state.userAccount.registeredCountryCode,
    registeredCountryName: state.userAccount.registeredCountryName,
    addPhoneNumberResponse: state.userAccount.addPhoneNumberResponse,
    isFetching: loadingSelector(state),
    error: state.userAccount.error,
    countryCodeListing: state.userAccount.countryCodeListing,

    setHelpListData: state.userAccount.setHelpListData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    doSaveRegistrationInfo: (data) => dispatch(saveRegistrationInfo(data)),
    doAddUserPhoneNumber: (data) => dispatch(addUserPhoneNumber(data)),
    userPhoneNumberClear: () => dispatch(userPhoneNumberClear()),
    doGetCountryCodes: () => dispatch(getCountryCodes()),
    dosetHelpList: (data) => dispatch(setHelpList(data)),
    doShowModal: (data) => dispatch(showModal(data)),
    doHideModal: () => dispatch(hideModal()),
  };
}
export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(RegisterPhone)
);
